import React, { useState, useEffect } from "react";
import Design from "./Design";
import {
  fetchEventDetails,
  fetchEventTopUsers,
  fetchEventRewards,
} from "../../services/benefitApi";

const NewEvents = () => {
  const [eventDetails, setEventDetails] = useState(null);
  const [topUsers, setTopUsers] = useState(null);
  const [rewards, setRewards] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const [detailsRes, topUsersRes, rewardsRes] = await Promise.all([
          fetchEventDetails(),
          fetchEventTopUsers(),
          fetchEventRewards(),
        ]);

        if (detailsRes.success) {
          setEventDetails(detailsRes.data);
        }
        if (topUsersRes.success) {
          setTopUsers(topUsersRes.data);
        }
        if (rewardsRes.success) {
          setRewards(rewardsRes.data);
        }
      } catch (err) {
        setError(err.message);
        console.error("API failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Design
        eventDetails={eventDetails}
        topUsers={topUsers}
        rewards={rewards}
        loading={loading}
      />
    </div>
  );
};

export default NewEvents;
